export const KIT_ROUTE_NAMES = {
    LIST: "KitsList",
    CARD: "KitCard",
    ADD: "KitAdd",
    EDIT: "KitEdit",
};
